<div *ngIf="status$ | ngrxPush as status" class="chip" [class]="status | invoke : getStatusClass">
    <dtm-ui-icon [name]="status | invoke : getStatusIconName"></dtm-ui-icon>
    <div #contentRef><ng-content></ng-content></div>
    <span *ngIf="!contentRef.children.length">{{ "sahSharedLibIncident.tasks.taskStatusValue" | transloco : { status } }}</span>
</div>
